var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopMobileLandingPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 265,
    opacity: 0.6,
    viewBox: "0 0 389 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_2269_1902)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34191 142.772C0.336349 156.256 -2.69446 173.094 3.11092 185.773C14.9579 211.637 49.6019 216.928 67.2663 195.023C72.6633 188.327 78.0643 180.831 86.2078 178.065C101.402 172.91 116.86 181.579 132.226 173.482C148.602 164.853 160.12 147.019 179.226 143.673C190.805 141.643 201.254 145.97 212.349 144.785C217.874 144.197 223.555 142.952 227.931 139.53C239.45 130.517 236.807 111.994 229.721 101.34C224.159 92.9828 215.836 86.6951 206.707 82.5086C185.936 72.979 162.274 78.0139 140.482 80.7395C127.422 82.3725 114.882 85.002 101.886 86.643C87.4289 88.4641 73.0276 91.3578 59.375 96.5529C40.8098 103.613 23.5218 115.232 12.4235 131.702C10.2335 134.951 8.15158 138.71 6.34191 142.776V142.772Z",
    fill: "#67CFEE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362.76 163.972C363.14 162.779 363.424 161.567 363.617 160.338L361.371 162.583L357.107 166.846L352.843 171.108L348.579 175.371L344.315 179.633L343.39 180.558C343.91 180.478 344.431 180.378 344.947 180.266C346.469 179.925 347.962 179.441 349.407 178.805L350.709 177.504L354.973 173.241L359.237 168.979L361.855 166.357C362.199 165.577 362.5 164.78 362.756 163.976L362.76 163.972Z",
    fill: "#FFDE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.371 154.062L357.107 158.325L352.843 162.587L348.579 166.85L344.315 171.112L340.051 175.375L335.787 179.637L335.014 180.41C335.623 180.526 336.231 180.618 336.844 180.69C337.508 180.766 338.177 180.814 338.846 180.838L342.181 177.504L346.445 173.241L350.709 168.979L354.973 164.716L359.237 160.454L363.501 156.191L363.893 155.799C363.853 154.514 363.709 153.234 363.464 151.965L361.371 154.058V154.062Z",
    fill: "#FFDE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M357.111 149.803L352.847 154.066L348.583 158.328L344.319 162.591L340.055 166.854L335.791 171.116L331.527 175.379L328.664 178.24C329.637 178.732 330.634 179.157 331.655 179.513L333.657 177.512L337.921 173.249L342.185 168.987L346.449 164.724L350.713 160.462L354.977 156.199L359.241 151.937L362.564 148.615C362.211 147.598 361.787 146.598 361.29 145.625L357.111 149.803Z",
    fill: "#FFDE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357.111 141.283L352.847 145.546L348.583 149.808L344.319 154.071L340.055 158.333L335.791 162.596L331.527 166.858L327.263 171.121L323.588 174.795C324.356 175.475 325.157 176.096 325.986 176.66L329.393 173.254L333.657 168.991L337.921 164.729L342.185 160.466L346.449 156.204L350.713 151.941L354.977 147.679L359.241 143.416L359.705 142.952C359.141 142.124 358.52 141.323 357.839 140.555L357.107 141.287L357.111 141.283Z",
    fill: "#FFDE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M352.847 137.02L348.583 141.283L344.319 145.545L340.055 149.808L335.791 154.07L331.527 158.333L327.263 162.595L322.999 166.858L319.588 170.268C320.152 171.096 320.777 171.893 321.454 172.661L325.129 168.987L329.393 164.724L333.657 160.462L337.921 156.199L342.185 151.937L346.449 147.674L350.713 143.412L354.977 139.149L355.709 138.417C354.941 137.736 354.144 137.116 353.315 136.552L352.847 137.02Z",
    fill: "#FFDE00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M344.323 137.02L340.059 141.283L335.795 145.545L331.531 149.808L327.267 154.07L323.003 158.333L318.739 162.595L316.729 164.605C317.086 165.621 317.51 166.618 318.002 167.59L320.869 164.725L325.133 160.462L329.397 156.2L333.661 151.937L337.925 147.675L342.189 143.412L346.453 139.15L350.641 134.963C349.668 134.471 348.671 134.043 347.654 133.69L344.323 137.02Z",
    fill: "#FFDE00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M340.063 132.762L335.799 137.024L331.535 141.287L327.271 145.549L323.007 149.812L318.743 154.074L315.396 157.42C315.42 158.081 315.468 158.737 315.54 159.393C315.612 160.014 315.708 160.634 315.824 161.251L316.609 160.466L320.873 156.204L325.137 151.941L329.401 147.679L333.665 143.416L337.929 139.154L342.193 134.891L344.299 132.786C343.034 132.542 341.752 132.398 340.467 132.354L340.063 132.758V132.762Z",
    fill: "#FFDE00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M329.937 134.359L327.275 137.021L323.011 141.283L318.747 145.546L317.406 146.886C316.781 148.315 316.305 149.788 315.968 151.289C315.852 151.817 315.752 152.35 315.668 152.882L316.613 151.937L320.877 147.675L325.141 143.412L329.405 139.15L333.669 134.887L335.935 132.622C334.694 132.814 333.469 133.098 332.264 133.483C331.479 133.735 330.702 134.023 329.937 134.355V134.359Z",
    fill: "#FFDE00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.006 161.675C213.162 162.519 213.149 163.876 213.966 164.737C214.655 163.532 215.275 162.303 215.836 161.05C215.183 160.966 214.503 161.174 214.002 161.675H214.006Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.899 167.887C210.043 167.03 208.653 167.03 207.792 167.887C206.936 168.743 206.936 170.136 207.792 170.992C208.157 171.357 208.613 171.565 209.09 171.617C209.91 170.668 210.687 169.696 211.412 168.695C211.304 168.399 211.136 168.123 210.899 167.883V167.887Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M204.685 174.098C203.829 173.242 202.439 173.242 201.579 174.098C200.722 174.955 200.722 176.348 201.579 177.204C201.851 177.476 202.179 177.665 202.528 177.761C203.48 177.036 204.413 176.268 205.318 175.455C205.274 174.959 205.062 174.475 204.682 174.098H204.685Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M198.472 180.31C197.615 179.454 196.226 179.454 195.365 180.31C194.788 180.887 194.6 181.699 194.8 182.432C196.085 181.831 197.347 181.163 198.58 180.426C198.544 180.386 198.512 180.346 198.472 180.31Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219.583 144.689C219.583 144.577 219.591 144.469 219.591 144.356C219.579 144.469 219.575 144.577 219.583 144.689Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.006 149.252C213.149 150.108 213.149 151.501 214.006 152.358C214.863 153.214 216.256 153.214 217.113 152.358C217.97 151.501 217.97 150.108 217.113 149.252C216.256 148.395 214.867 148.395 214.006 149.252Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M207.792 155.464C206.936 156.32 206.936 157.713 207.792 158.57C208.649 159.426 210.043 159.426 210.899 158.57C211.756 157.713 211.756 156.32 210.899 155.464C210.043 154.607 208.653 154.607 207.792 155.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M201.579 161.675C200.722 162.531 200.722 163.924 201.579 164.78C202.435 165.637 203.829 165.637 204.685 164.78C205.542 163.924 205.542 162.531 204.685 161.675C203.829 160.818 202.439 160.818 201.579 161.675Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M195.365 167.887C194.508 168.743 194.508 170.136 195.365 170.992C196.222 171.849 197.615 171.849 198.472 170.992C199.329 170.136 199.329 168.743 198.472 167.887C197.615 167.03 196.226 167.03 195.365 167.887Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M189.151 174.098C188.294 174.955 188.294 176.348 189.151 177.204C190.008 178.061 191.401 178.061 192.258 177.204C193.115 176.348 193.115 174.955 192.258 174.098C191.401 173.242 190.012 173.242 189.151 174.098Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M182.938 180.31C182.081 181.167 182.081 182.56 182.938 183.416C183.794 184.273 185.188 184.273 186.044 183.416C186.901 182.56 186.901 181.167 186.044 180.31C185.184 179.454 183.798 179.454 182.938 180.31Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M176.768 186.481C177.733 186.477 178.702 186.441 179.667 186.369C178.818 185.677 177.577 185.713 176.768 186.481Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M217.113 136.828C216.256 135.971 214.867 135.971 214.006 136.828C213.149 137.684 213.149 139.077 214.006 139.934C214.863 140.79 216.256 140.79 217.113 139.934C217.97 139.077 217.97 137.684 217.113 136.828Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M210.899 143.04C210.043 142.183 208.653 142.183 207.792 143.04C206.936 143.896 206.936 145.289 207.792 146.146C208.649 147.002 210.043 147.002 210.899 146.146C211.756 145.289 211.756 143.896 210.899 143.04Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M204.685 149.252C203.829 148.395 202.439 148.395 201.579 149.252C200.722 150.108 200.722 151.501 201.579 152.358C202.435 153.214 203.829 153.214 204.685 152.358C205.542 151.501 205.542 150.108 204.685 149.252Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M198.472 155.464C197.615 154.607 196.226 154.607 195.365 155.464C194.508 156.32 194.508 157.713 195.365 158.57C196.222 159.426 197.615 159.426 198.472 158.57C199.329 157.713 199.329 156.32 198.472 155.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M192.258 161.675C191.401 160.818 190.012 160.818 189.151 161.675C188.294 162.531 188.294 163.924 189.151 164.78C190.008 165.637 191.401 165.637 192.258 164.78C193.115 163.924 193.115 162.531 192.258 161.675Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M186.044 167.887C185.184 167.03 183.798 167.03 182.938 167.887C182.081 168.743 182.081 170.136 182.938 170.992C183.794 171.849 185.188 171.849 186.044 170.992C186.901 170.136 186.901 168.743 186.044 167.887Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M176.724 174.098C175.867 174.955 175.867 176.348 176.724 177.204C177.584 178.061 178.974 178.061 179.831 177.204C180.687 176.348 180.687 174.955 179.831 174.098C178.974 173.242 177.584 173.242 176.724 174.098Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M170.51 180.31C169.653 181.167 169.653 182.56 170.51 183.416C171.367 184.273 172.76 184.273 173.617 183.416C174.474 182.56 174.474 181.167 173.617 180.31C172.76 179.454 171.371 179.454 170.51 180.31Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M214.006 127.51C214.735 128.239 215.844 128.347 216.689 127.839C216.164 126.49 215.572 125.161 214.907 123.86C214.579 123.964 214.266 124.145 214.006 124.405C213.149 125.261 213.149 126.654 214.006 127.51Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M210.899 130.617C210.043 129.76 208.653 129.76 207.792 130.617C206.936 131.473 206.936 132.866 207.792 133.723C208.649 134.579 210.043 134.579 210.899 133.723C211.756 132.866 211.756 131.473 210.899 130.617Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M204.685 136.828C203.829 135.971 202.439 135.971 201.579 136.828C200.722 137.684 200.722 139.077 201.579 139.934C202.435 140.79 203.829 140.79 204.685 139.934C205.542 139.077 205.542 137.684 204.685 136.828Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M198.472 143.04C197.615 142.183 196.226 142.183 195.365 143.04C194.508 143.896 194.508 145.289 195.365 146.146C196.222 147.002 197.615 147.002 198.472 146.146C199.329 145.289 199.329 143.896 198.472 143.04Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M192.258 149.252C191.401 148.395 190.012 148.395 189.151 149.252C188.294 150.108 188.294 151.501 189.151 152.358C190.008 153.214 191.401 153.214 192.258 152.358C193.115 151.501 193.115 150.108 192.258 149.252Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M186.044 155.464C185.184 154.607 183.798 154.607 182.938 155.464C182.081 156.32 182.081 157.713 182.938 158.57C183.794 159.426 185.188 159.426 186.044 158.57C186.901 157.713 186.901 156.32 186.044 155.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M179.831 161.675C178.974 160.818 177.584 160.818 176.724 161.675C175.867 162.531 175.867 163.924 176.724 164.78C177.584 165.637 178.974 165.637 179.831 164.78C180.687 163.924 180.687 162.531 179.831 161.675Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M173.617 167.887C172.76 167.03 171.371 167.03 170.51 167.887C169.653 168.743 169.653 170.136 170.51 170.992C171.367 171.849 172.76 171.849 173.617 170.992C174.474 170.136 174.474 168.743 173.617 167.887Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M164.296 174.098C163.439 174.955 163.439 176.348 164.296 177.204C165.153 178.061 166.546 178.061 167.403 177.204C168.26 176.348 168.26 174.955 167.403 174.098C166.546 173.242 165.157 173.242 164.296 174.098Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M161.193 183.416C162.05 182.56 162.05 181.167 161.193 180.31C160.337 179.454 158.947 179.454 158.086 180.31C157.61 180.787 157.402 181.423 157.45 182.043C158.611 182.616 159.792 183.132 160.989 183.592C161.061 183.536 161.129 183.48 161.193 183.412V183.416Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M210.899 118.193C210.043 117.337 208.653 117.337 207.792 118.193C206.936 119.05 206.936 120.442 207.792 121.299C208.649 122.155 210.043 122.155 210.899 121.299C211.756 120.442 211.756 119.05 210.899 118.193Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M204.685 124.405C203.829 123.549 202.439 123.549 201.579 124.405C200.722 125.262 200.722 126.654 201.579 127.511C202.435 128.367 203.829 128.367 204.685 127.511C205.542 126.654 205.542 125.262 204.685 124.405Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M198.472 130.617C197.615 129.76 196.226 129.76 195.365 130.617C194.508 131.473 194.508 132.866 195.365 133.723C196.222 134.579 197.615 134.579 198.472 133.723C199.329 132.866 199.329 131.473 198.472 130.617Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M192.258 136.828C191.401 135.971 190.012 135.971 189.151 136.828C188.294 137.684 188.294 139.077 189.151 139.934C190.008 140.79 191.401 140.79 192.258 139.934C193.115 139.077 193.115 137.684 192.258 136.828Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M186.044 143.04C185.188 142.183 183.798 142.183 182.938 143.04C182.081 143.896 182.081 145.289 182.938 146.146C183.794 147.002 185.188 147.002 186.044 146.146C186.901 145.289 186.901 143.896 186.044 143.04Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M179.831 149.252C178.974 148.395 177.584 148.395 176.724 149.252C175.867 150.108 175.867 151.501 176.724 152.358C177.584 153.214 178.974 153.214 179.831 152.358C180.687 151.501 180.687 150.108 179.831 149.252Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M173.617 155.464C172.76 154.607 171.371 154.607 170.51 155.464C169.653 156.32 169.653 157.713 170.51 158.57C171.367 159.426 172.76 159.426 173.617 158.57C174.474 157.713 174.474 156.32 173.617 155.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M167.403 161.675C166.546 160.818 165.157 160.818 164.296 161.675C163.439 162.531 163.439 163.924 164.296 164.78C165.153 165.637 166.546 165.637 167.403 164.78C168.26 163.924 168.26 162.531 167.403 161.675Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M158.086 167.887C157.23 168.743 157.23 170.136 158.086 170.992C158.943 171.849 160.333 171.849 161.193 170.992C162.05 170.136 162.05 168.743 161.193 167.887C160.337 167.03 158.947 167.03 158.086 167.887Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M151.869 174.098C151.012 174.955 151.012 176.348 151.869 177.204C152.725 178.061 154.119 178.061 154.976 177.204C155.832 176.348 155.832 174.955 154.976 174.098C154.119 173.242 152.729 173.242 151.869 174.098Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M204.685 111.981C203.829 111.125 202.439 111.125 201.579 111.981C200.722 112.838 200.722 114.231 201.579 115.087C202.435 115.944 203.829 115.944 204.685 115.087C205.542 114.227 205.542 112.838 204.685 111.981Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M198.472 118.193C197.615 117.337 196.226 117.337 195.365 118.193C194.508 119.05 194.508 120.442 195.365 121.299C196.222 122.155 197.615 122.155 198.472 121.299C199.329 120.442 199.329 119.05 198.472 118.193Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M192.258 124.405C191.401 123.549 190.012 123.549 189.151 124.405C188.294 125.262 188.294 126.654 189.151 127.511C190.008 128.367 191.401 128.367 192.258 127.511C193.115 126.654 193.115 125.262 192.258 124.405Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M186.044 130.617C185.188 129.76 183.798 129.76 182.938 130.617C182.081 131.473 182.081 132.866 182.938 133.723C183.794 134.579 185.188 134.579 186.044 133.723C186.901 132.866 186.901 131.473 186.044 130.617Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M179.831 136.828C178.974 135.971 177.584 135.971 176.724 136.828C175.867 137.684 175.867 139.077 176.724 139.934C177.584 140.79 178.974 140.79 179.831 139.934C180.687 139.077 180.687 137.684 179.831 136.828Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M173.617 143.04C172.76 142.183 171.371 142.183 170.51 143.04C169.653 143.896 169.653 145.289 170.51 146.146C171.367 147.002 172.76 147.002 173.617 146.146C174.474 145.289 174.474 143.896 173.617 143.04Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M167.403 149.252C166.546 148.395 165.157 148.395 164.296 149.252C163.435 150.108 163.435 151.501 164.296 152.358C165.153 153.214 166.546 153.214 167.403 152.358C168.26 151.501 168.26 150.108 167.403 149.252Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M161.189 155.464C160.332 154.607 158.943 154.607 158.082 155.464C157.225 156.32 157.225 157.713 158.082 158.57C158.939 159.426 160.328 159.426 161.189 158.57C162.046 157.713 162.046 156.32 161.189 155.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M154.976 161.675C154.119 160.818 152.729 160.818 151.869 161.675C151.012 162.531 151.012 163.924 151.869 164.78C152.725 165.637 154.119 165.637 154.976 164.78C155.832 163.924 155.832 162.531 154.976 161.675Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M145.655 167.887C144.798 168.743 144.798 170.136 145.655 170.992C146.512 171.849 147.905 171.849 148.762 170.992C149.618 170.136 149.618 168.743 148.762 167.887C147.905 167.03 146.516 167.03 145.655 167.887Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M195.365 108.879C196.222 109.736 197.615 109.736 198.472 108.879C199.06 108.291 199.245 107.446 199.024 106.702C198.156 106.17 197.271 105.669 196.37 105.201C196.002 105.297 195.653 105.485 195.365 105.774C194.508 106.63 194.508 108.023 195.365 108.879Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M192.258 111.986C191.401 111.13 190.012 111.13 189.151 111.986C188.294 112.843 188.294 114.235 189.151 115.092C190.008 115.948 191.401 115.948 192.258 115.092C193.115 114.235 193.115 112.843 192.258 111.986Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M186.044 118.193C185.188 117.337 183.798 117.337 182.938 118.193C182.081 119.05 182.081 120.442 182.938 121.299C183.794 122.155 185.188 122.155 186.044 121.299C186.901 120.442 186.901 119.05 186.044 118.193Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M179.831 124.405C178.974 123.549 177.584 123.549 176.724 124.405C175.867 125.262 175.867 126.654 176.724 127.511C177.584 128.367 178.974 128.367 179.831 127.511C180.687 126.654 180.687 125.262 179.831 124.405Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M173.617 130.617C172.76 129.76 171.371 129.76 170.51 130.617C169.653 131.473 169.653 132.866 170.51 133.723C171.367 134.579 172.76 134.579 173.617 133.723C174.474 132.866 174.474 131.473 173.617 130.617Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M167.403 136.828C166.546 135.971 165.157 135.971 164.296 136.828C163.435 137.684 163.435 139.077 164.296 139.934C165.153 140.79 166.546 140.79 167.403 139.934C168.26 139.077 168.26 137.684 167.403 136.828Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M161.189 143.04C160.332 142.183 158.943 142.183 158.082 143.04C157.225 143.896 157.225 145.289 158.082 146.146C158.939 147.002 160.328 147.002 161.189 146.146C162.046 145.289 162.046 143.896 161.189 143.04Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M154.976 149.252C154.119 148.395 152.729 148.395 151.869 149.252C151.012 150.108 151.012 151.501 151.869 152.358C152.725 153.214 154.119 153.214 154.976 152.358C155.832 151.501 155.832 150.108 154.976 149.252Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M148.762 155.464C147.905 154.607 146.516 154.607 145.655 155.464C144.798 156.32 144.798 157.713 145.655 158.57C146.512 159.426 147.905 159.426 148.762 158.57C149.618 157.713 149.618 156.32 148.762 155.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M139.445 161.675C138.588 162.531 138.588 163.924 139.445 164.78C140.302 165.637 141.695 165.637 142.552 164.78C143.409 163.924 143.409 162.531 142.552 161.675C141.695 160.818 140.306 160.818 139.445 161.675Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M189.151 102.668C189.824 103.34 190.829 103.485 191.641 103.1C190.689 102.744 189.728 102.424 188.759 102.136C188.859 102.328 188.991 102.508 189.151 102.668Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M186.044 105.774C185.188 104.914 183.798 104.914 182.938 105.774C182.081 106.631 182.081 108.024 182.938 108.88C183.794 109.737 185.188 109.737 186.044 108.88C186.901 108.024 186.901 106.631 186.044 105.774Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M179.831 111.986C178.974 111.13 177.584 111.13 176.724 111.986C175.867 112.843 175.867 114.235 176.724 115.092C177.584 115.948 178.974 115.948 179.831 115.092C180.687 114.235 180.687 112.843 179.831 111.986Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M173.617 118.193C172.76 117.337 171.371 117.337 170.51 118.193C169.653 119.05 169.653 120.442 170.51 121.299C171.367 122.155 172.76 122.155 173.617 121.299C174.474 120.442 174.474 119.05 173.617 118.193Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M167.403 124.405C166.546 123.549 165.157 123.549 164.296 124.405C163.435 125.262 163.435 126.654 164.296 127.511C165.153 128.367 166.546 128.367 167.403 127.511C168.26 126.654 168.26 125.262 167.403 124.405Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M161.189 130.617C160.332 129.76 158.943 129.76 158.082 130.617C157.225 131.473 157.225 132.866 158.082 133.723C158.939 134.579 160.328 134.579 161.189 133.723C162.046 132.866 162.046 131.473 161.189 130.617Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M154.976 136.832C154.119 135.975 152.729 135.975 151.869 136.832C151.012 137.688 151.012 139.081 151.869 139.938C152.725 140.794 154.119 140.794 154.976 139.938C155.832 139.081 155.832 137.688 154.976 136.832Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M148.766 143.04C147.909 142.183 146.52 142.183 145.659 143.04C144.802 143.896 144.802 145.289 145.659 146.146C146.516 147.002 147.909 147.002 148.766 146.146C149.623 145.289 149.623 143.896 148.766 143.04Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M142.548 149.252C141.691 148.395 140.302 148.395 139.441 149.252C138.584 150.108 138.584 151.501 139.441 152.358C140.298 153.214 141.691 153.214 142.548 152.358C143.405 151.501 143.405 150.108 142.548 149.252Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M136.338 155.463C135.962 155.087 135.482 154.875 134.993 154.831C135.345 156.124 135.762 157.401 136.238 158.665C136.274 158.633 136.306 158.605 136.342 158.573C137.199 157.717 137.199 156.324 136.342 155.467L136.338 155.463Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M176.724 102.668C177.584 103.525 178.974 103.525 179.831 102.668C180.407 102.092 180.591 101.279 180.395 100.547C179.002 100.423 177.604 100.367 176.207 100.375C175.931 101.151 176.099 102.048 176.72 102.668H176.724Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M173.617 105.774C172.76 104.914 171.371 104.914 170.51 105.774C169.653 106.631 169.653 108.024 170.51 108.88C171.367 109.737 172.76 109.737 173.617 108.88C174.474 108.024 174.474 106.631 173.617 105.774Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M167.403 111.986C166.546 111.13 165.157 111.13 164.296 111.986C163.435 112.843 163.435 114.235 164.296 115.092C165.153 115.948 166.546 115.948 167.403 115.092C168.26 114.235 168.26 112.843 167.403 111.986Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M161.189 118.197C160.332 117.341 158.943 117.341 158.082 118.197C157.225 119.054 157.225 120.446 158.082 121.303C158.939 122.159 160.328 122.159 161.189 121.303C162.046 120.446 162.046 119.054 161.189 118.197Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M154.976 124.405C154.119 123.549 152.729 123.549 151.869 124.405C151.012 125.262 151.012 126.654 151.869 127.511C152.725 128.367 154.119 128.367 154.976 127.511C155.832 126.654 155.832 125.262 154.976 124.405Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M148.766 130.617C147.909 129.76 146.52 129.76 145.659 130.617C144.802 131.473 144.802 132.866 145.659 133.723C146.516 134.579 147.909 134.579 148.766 133.723C149.623 132.866 149.623 131.473 148.766 130.617Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M142.548 136.832C141.691 135.975 140.302 135.975 139.441 136.832C138.584 137.688 138.584 139.081 139.441 139.938C140.298 140.794 141.691 140.794 142.548 139.938C143.405 139.081 143.405 137.688 142.548 136.832Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M136.338 143.04C135.554 142.256 134.328 142.192 133.468 142.84C133.452 144.033 133.484 145.23 133.564 146.418C134.417 146.991 135.586 146.899 136.338 146.146C137.195 145.29 137.195 143.897 136.338 143.04Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M164.3 102.668C165.157 103.524 166.55 103.524 167.407 102.668C167.811 102.264 168.024 101.739 168.044 101.211C166.67 101.487 165.309 101.827 163.964 102.236C164.056 102.388 164.164 102.536 164.296 102.668H164.3Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M161.189 105.774C160.332 104.914 158.943 104.914 158.082 105.774C157.225 106.631 157.225 108.024 158.082 108.88C158.939 109.737 160.328 109.737 161.189 108.88C162.046 108.024 162.046 106.631 161.189 105.774Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M154.979 111.986C154.123 111.13 152.733 111.13 151.873 111.986C151.016 112.843 151.016 114.235 151.873 115.092C152.729 115.948 154.123 115.948 154.979 115.092C155.836 114.235 155.836 112.843 154.979 111.986Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M148.766 118.197C147.909 117.341 146.52 117.341 145.659 118.197C144.802 119.054 144.802 120.446 145.659 121.303C146.516 122.159 147.909 122.159 148.766 121.303C149.623 120.446 149.623 119.054 148.766 118.197Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M142.548 124.405C141.691 123.549 140.302 123.549 139.441 124.405C138.584 125.262 138.584 126.654 139.441 127.511C140.298 128.367 141.691 128.367 142.548 127.511C143.405 126.654 143.405 125.262 142.548 124.405Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M136.338 133.722C137.195 132.866 137.195 131.473 136.338 130.617C136.11 130.388 135.842 130.224 135.562 130.116C135.113 131.505 134.733 132.914 134.428 134.335C135.105 134.447 135.818 134.243 136.338 133.722Z",
    fill: "#67CFEE"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6171 173.061H48.0406C46.7794 173.061 45.7505 172.033 45.7505 170.772V170.196C45.7505 168.935 46.7794 167.906 48.0406 167.906H48.6171C49.8783 167.906 50.9073 168.935 50.9073 170.196V170.772C50.9073 172.033 49.8783 173.061 48.6171 173.061ZM37.8352 172.165L37.639 171.62C37.2066 170.436 35.8854 169.819 34.7043 170.252L34.1598 170.448C32.9747 170.88 32.3581 172.201 32.7905 173.381L32.9867 173.926C33.4191 175.11 34.7403 175.727 35.9214 175.295L36.4659 175.098C37.651 174.666 38.2676 173.345 37.8352 172.165ZM26.0282 177.944L25.6559 177.5C24.8471 176.535 23.3938 176.407 22.4289 177.216L21.9845 177.588C21.0196 178.396 20.8915 179.849 21.7002 180.814L22.0726 181.258C22.8813 182.223 24.3347 182.351 25.2996 181.542L25.744 181.17C26.7089 180.362 26.837 178.909 26.0282 177.944ZM16.9118 187.414L16.4113 187.126C15.3183 186.497 13.913 186.873 13.2804 187.962L12.9922 188.462C12.3636 189.555 12.7399 190.96 13.8289 191.592L14.3294 191.88C15.4224 192.509 16.8277 192.132 17.4603 191.044L17.7486 190.544C18.3772 189.451 18.0008 188.046 16.9118 187.414ZM11.5829 199.429L11.0143 199.329C9.77319 199.109 8.58009 199.945 8.35988 201.186L8.25979 201.754C8.03959 202.995 8.87636 204.188 10.1175 204.408L10.686 204.508C11.9272 204.728 13.1203 203.891 13.3405 202.651L13.4406 202.082C13.6608 200.842 12.824 199.649 11.5829 199.429ZM10.686 212.541L10.1175 212.641C8.87636 212.861 8.03959 214.053 8.25979 215.294L8.35988 215.862C8.58009 217.103 9.77319 217.94 11.0143 217.72L11.5829 217.62C12.824 217.399 13.6608 216.207 13.4406 214.966L13.3405 214.398C13.1203 213.157 11.9272 212.32 10.686 212.541ZM14.3294 225.168L13.8289 225.456C12.7359 226.084 12.3596 227.493 12.9922 228.586L13.2804 229.086C13.909 230.179 15.3183 230.555 16.4113 229.923L16.9118 229.635C18.0048 229.006 18.3812 227.597 17.7486 226.505L17.4603 226.004C16.8317 224.912 15.4224 224.536 14.3294 225.168ZM22.0726 235.786L21.7002 236.23C20.8915 237.195 21.0156 238.648 21.9845 239.456L22.4289 239.829C23.3938 240.637 24.8471 240.513 25.6559 239.544L26.0282 239.1C26.837 238.136 26.7129 236.683 25.744 235.874L25.2996 235.502C24.3347 234.694 22.8813 234.818 22.0726 235.786ZM32.9827 243.119L32.7865 243.663C32.3541 244.848 32.9707 246.168 34.1558 246.597L34.7003 246.793C35.8854 247.225 37.2066 246.609 37.635 245.424L37.8312 244.88C38.2636 243.695 37.647 242.374 36.4619 241.946L35.9174 241.75C34.7323 241.317 33.4111 241.934 32.9827 243.119ZM45.7425 246.276V246.853C45.7425 248.114 46.7714 249.142 48.0326 249.142H48.6091C49.8703 249.142 50.8993 248.114 50.8993 246.853V246.276C50.8993 245.016 49.8703 243.987 48.6091 243.987H48.0326C46.7714 243.987 45.7425 245.016 45.7425 246.276ZM58.8146 244.884L59.0108 245.428C59.4432 246.613 60.7644 247.229 61.9455 246.797L62.49 246.601C63.6751 246.168 64.2916 244.848 63.8592 243.667L63.6631 243.123C63.2307 241.938 61.9094 241.322 60.7283 241.754L60.1838 241.95C58.9988 242.382 58.3822 243.703 58.8146 244.884ZM70.6215 239.104L70.9939 239.548C71.8026 240.513 73.2559 240.641 74.2208 239.833L74.6653 239.46C75.6301 238.652 75.7583 237.199 74.9495 236.234L74.5772 235.79C73.7684 234.826 72.3151 234.698 71.3502 235.506L70.9058 235.878C69.9409 236.687 69.8128 238.14 70.6215 239.104ZM79.7379 229.635L80.2384 229.923C81.3314 230.551 82.7367 230.175 83.3693 229.086L83.6576 228.586C84.2861 227.493 83.9098 226.088 82.8208 225.456L82.3203 225.168C81.2273 224.54 79.822 224.916 79.1894 226.004L78.9012 226.505C78.2726 227.597 78.6489 229.002 79.7379 229.635ZM85.0669 217.62L85.6354 217.72C86.8765 217.94 88.0697 217.103 88.2899 215.862L88.39 215.294C88.6102 214.053 87.7734 212.861 86.5322 212.641L85.9637 212.541C84.7226 212.32 83.5294 213.157 83.3092 214.398L83.2092 214.966C82.989 216.207 83.8257 217.399 85.0669 217.62ZM85.9637 204.508L86.5322 204.408C87.7734 204.188 88.6102 202.995 88.39 201.754L88.2899 201.186C88.0697 199.945 86.8765 199.109 85.6354 199.329L85.0669 199.429C83.8257 199.649 82.989 200.842 83.2092 202.082L83.3092 202.651C83.5294 203.891 84.7226 204.728 85.9637 204.508ZM82.3203 191.88L82.8208 191.592C83.9138 190.964 84.2902 189.555 83.6576 188.462L83.3693 187.962C82.7407 186.869 81.3314 186.493 80.2384 187.126L79.7379 187.414C78.6449 188.042 78.2686 189.451 78.9012 190.544L79.1894 191.044C79.818 192.136 81.2273 192.513 82.3203 191.88ZM74.5772 181.262L74.9495 180.818C75.7583 179.853 75.6341 178.4 74.6653 177.592L74.2208 177.22C73.2559 176.411 71.8026 176.535 70.9939 177.504L70.6215 177.948C69.8128 178.913 69.9369 180.366 70.9058 181.174L71.3502 181.546C72.3151 182.355 73.7684 182.231 74.5772 181.262ZM63.6671 173.93L63.8632 173.385C64.2956 172.201 63.6791 170.88 62.494 170.452L61.9495 170.256C60.7644 169.823 59.4432 170.44 59.0148 171.624L58.8186 172.169C58.3862 173.353 59.0028 174.674 60.1879 175.102L60.7324 175.299C61.9174 175.731 63.2387 175.114 63.6671 173.93Z",
    fill: "#FFDE00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M397.445 -55.4423C399.679 -53.301 399.755 -49.755 397.613 -47.5216L197.307 161.405C195.165 163.639 191.618 163.715 189.384 161.574C187.15 159.432 187.074 155.886 189.216 153.653L389.521 -55.2742C391.663 -57.5075 395.211 -57.5836 397.445 -55.4423ZM175.723 176.062C177.953 178.199 181.493 178.123 183.631 175.894C185.769 173.665 185.693 170.127 183.463 167.989C181.232 165.852 177.693 165.928 175.555 168.157C173.417 170.387 173.493 173.925 175.723 176.062Z",
    fill: "#FFDE00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M199.57 200.296C195.366 196.266 195.222 189.594 199.254 185.387L576.167 -207.752C580.198 -211.955 586.872 -212.099 591.08 -208.068C595.284 -204.038 595.428 -197.366 591.397 -193.16L214.48 199.98C210.448 204.182 203.774 204.327 199.566 200.296H199.57Z",
    fill: "#67CFEE"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M105.249 156.88C109.818 156.88 113.521 153.177 113.521 148.611C113.521 144.044 109.818 140.342 105.249 140.342C100.681 140.342 96.9778 144.044 96.9778 148.611C96.9778 153.177 100.681 156.88 105.249 156.88Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6482 192.949C83.9125 192.949 92.2334 184.631 92.2334 174.37C92.2334 164.109 83.9125 155.791 73.6482 155.791C63.3839 155.791 55.063 164.109 55.063 174.37C55.063 184.631 63.3839 192.949 73.6482 192.949Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2269_1902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 644,
    height: 516,
    fill: "white",
    transform: "translate(0 -251)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopMobileLandingPage);
export default __webpack_public_path__ + "static/media/topMobileLandingPage.df0d6c0975c64a1b1764434ed25e5a2f.svg";
export { ForwardRef as ReactComponent };